import '../../config';
import { ppdLagoon } from '@sde/core/src/tools/lagoon';

export const loadFeatures = async (appKey, callback) => {
  // TODO: Ask other apps to remove this func
};

export const getFeature = (key) => {
  const { featureFlags } = ppdLagoon;
  return featureFlags[key] || false;
};

export const getFeatureToggle = (key) => {
  return getFeature(key);
};
